/* unplugin-vue-components disabled */import { render } from "./datasource.vue?vue&type=template&id=7d3172de&scoped=true"
import script from "./datasource.vue?vue&type=script&lang=js"
export * from "./datasource.vue?vue&type=script&lang=js"

import "./datasource.vue?vue&type=style&index=0&id=7d3172de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3172de"]])

export default __exports__